/** One semantic version for the API, frontend and instrument engine.
 * Score/URL format version numbers are independent serialization contracts.
 */
export const BOP_VERSION = "3.5.0";
export const BOP_RELEASE = Object.freeze({version:BOP_VERSION,api:BOP_VERSION,instruments:BOP_VERSION,frontend:BOP_VERSION});
